// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2TRY8","radioRow":"SimpleQuestionBuilderModal_radioRow__1BBL-"};